export function QuantityBadge({ quantity }: { quantity: number }) {
   return (
      <div className="quantity absolute end-0 top-0 translate-x-1/4 -translate-y-1/4 flex items-center justify-center h-[18px] px-1 bg-gray-200 border border-gray-300 rounded-sm text-sm">{`×${quantity}`}</div>
   );
}
